<template>
  <div>
    <el-tabs v-model="activeName" type="border-card" @tab-click="tabclick">
      <el-tab-pane label="首页" name="first">
        <div class="storebox">
          <div class="storeboxl">
            <div class="ckszbox">
              <h3>串口设置</h3>
              <div class="ckszboxnr">
                <span class="title">串口号</span>
                <div>
                  <h3 style="cursor:pointer;" @click.stop="flag2 = !flag2">{{ ckh }}</h3>
                  <span class="clan" style="cursor:pointer;" @click.stop="flag2 = !flag2"
                    ><img
                      :class="{ active: flag2 }"
                      src="../../assets/工厂测试_slices/Polygon1.png"
                      alt=""
                  /></span>
                </div>

                <ul class="xzq" v-if="flag2">
                  <li
                    v-for="(item, index) in list"
                    :key="index"
                    style="cursor:pointer;"
                    @click.stop="change(item)"
                  >
                    {{ item }}
                  </li>
                </ul>
                 <div class="dkzt">{{ dkorgb }}</div>
              </div>
             <div class="dkan" >
              <div style="cursor: pointer"  @click="OpenPort">打开</div>
              <div style="cursor: pointer"  @click="ClosePort">关闭</div>
             </div>
            </div>

            <div class="szyj">
              <h3>注册和绑定</h3>
              <div class="szyjt">
                <div class="zc" style="cursor:pointer;" @click="openDialogAddUser">注册</div>
              </div>
              <div class="szyjt">
                <div class="zh">
                  <div>账号</div>
                  <input type="text" v-model="userzh" placeholder="请输入账号" />
                </div>
                <div class="cx" style="cursor:pointer;" @click="clickQuery">绑定</div>
              </div>
            </div>
            <div class="qgd">
              <div class="qgdbox3">
              </div>
              <div>
                <el-steps :active="bznum" align-center finish-status="success">
                  <el-step title="步骤1" description="查询眼镜的编号"></el-step>
                  <el-step title="步骤2" description="绑定眼镜和用户"></el-step>
                </el-steps>
              </div>
            </div>
            <div class="szyj">
              <h3>设置屈光度</h3>
              <div class="szyjt">
                <div class="zh">
                  <div>屈光度</div>
                  <input type="text" v-model="setDataDiopter" placeholder="请输入屈光度" />
                </div>
                <div class="cx" style="cursor:pointer;" @click="clickSetDiopter">设置</div>
              </div>
            </div>
          </div>
          <div class="storeboxr">
            <div class="sjjsbox">
              <h3>串口数据接收<span class="back" @click="Quit">退出</span></h3>
              <div>
                <p><span class="time">时间</span><span class="hy">回应</span></p>
                <div ref="portMsgBox">
                  <li v-for="item in portDataList">
                    <span class="time">{{item.time}}</span><span>{{item.rv}}</span>
                  </li>
                </div>
              </div>
            </div>

            <div class="zjjcbox">
              <h3>门店复查</h3>
              <div class="zjjcboxnr">
                <li class="zjjcboxnr3">
                  <div style="cursor:pointer;" class="zjjcboxnr3l" @click="openDialogFucha">视光复查</div>
                </li>
                <li class="zjjcboxnr3">
                  <div style="cursor:pointer;" class="zjjcboxnr3l" @click="QueryUserTime">上传时长</div>
                  <div>
                    <div>设备使用时长:<span>{{deviceTime}}</span></div>
                  </div>
                </li>
                <li class="zjjcboxnr2" v-if="Roletype == 1">
                  <div style="cursor:pointer;" class="zjjcboxnr2l" @click="QueryCurRange">查询区间</div>
                  <div>
                    <p>编号:<span>{{portDataCurRangeIndex}}</span></p>
                  </div>
                </li>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="注册" name="second">
        <SubRslEvAddUser ref="SubRslEvAddUser"></SubRslEvAddUser>
      </el-tab-pane>
      <el-tab-pane label="客户管理" name="three">
        <SubRslEvManagementUser ref="SubRslEvManagementUser"></SubRslEvManagementUser>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import SubRslEvAddUser from '@/componentsRslEv/SubRslEvAddUser.vue'
import SubRslEvManagementUser from '@/componentsRslEv/SubRslEvManagementUser.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    SubRslEvAddUser,
    SubRslEvManagementUser
  },
  data () {
    return {
      activeName: 'first',
      Roletype: '3',
      bznum:-1,
      list: [],
      portDataList: [], // 串口数据
      ckh: 'COM1',
      flag2: false,
      dkorgb: '---',
      userzh: '',
      zqj: '0.00',
      yqj: '0.00',
      zzj: '0.00',
      yzj: '0.00',
      zzx: '0',
      yzx: '0',
      add: '0.00',
      tjfd: '0.00',
      jszt: 6,
      rage: '0',
      //
      ua: 'ua',
      portDataDianJi1: '',
      portDataDianJi2: '',
      portDataDianJi3: '',
      portDataDianJi4: '',
      portDataLight: '',
      portDataDistance: '',
      portDataCurRangeIndex: '',
      cpuId: '',
      deviceUserId: '',
      userTime: '',
      deviceTime: '',
      vol: '',
      //
      setDataDiopter: 0,
      deviceDiopter: '',
      sn: '0123',
      aCodeResult: '',
      // 查询CpuId的目的：1为了绑定；2设置度数，上传记录
      QueryCpuIdType: 0
    }
  },
  methods: {
    tabclick(){

    },
    change (name) {
      this.ckh = name
      this.flag2 = false
    },
    openDialogAddUser(){
      this.activeName = 'second'
      this.$refs.SubRslEvAddUser.initData()
    },
    openDialogFucha(){
      this.activeName = 'three'
      // this.$refs.SubRslEvManagementUser.clicksearch()
    },
    /// /////
    // 打开串口
    OpenPort () {
      this.dkorgb = window.external.OpenPort(this.ckh)
    },
    // 关闭串口
    ClosePort () {
      this.dkorgb = window.external.ClosePort()
    },
    // 心跳包
    HeartbeatPackets () {
      window.external.WritePortData('240D010101')
    },
    // 机构检测
    CheckJigou () {
      window.external.WritePortData('240A010101')
    },
    // 语音检测
    CheckVoice () {
      window.external.WritePortData('240C010101')
    },
    // 询问当前区间
    QueryCurRange () {
      window.external.WritePortData('2405010101')
    },
    // 设置屈光度
    SetDiopter () {
      var hex = window.external.IntToHexStr(this.setDataDiopter)
      var data = '240202' + hex + '00'
      window.external.WritePortData(data)
    },
    // 查询CPU ID
    QueryCpuId () {
      window.external.WritePortData('2406010101')
    },
    // 查询使用时长
    QueryUserTime () {
      window.external.WritePortData('2408010101')
    },
    // 设置产品设备号
    SetSn () {
      var time = new Date()
      // 年
      var fullYear = '' + time.getFullYear()
      var myYear = fullYear.slice(2)
      // 月
      var month = time.getMonth() + 1
      var myMonth = '' + month
      if (month < 10) {
        myMonth = '0' + month
      }
      // 日
      var date = time.getDate()
      var myDate = '' + date
      if (date < 10) {
        myDate = '0' + date
      }
      // 处理流水号
      var snint = parseInt(this.sn)
      var snstr = ''
      if (snint < 10) {
        snstr = '000' + snint
      } else if (snint < 100) {
        snstr = '00' + snint
      } else if (snint < 1000) {
        snstr = '0' + snint
      } else {
        snstr = '' + snint
      }
      var data = '240B0602' + myYear + myMonth + myDate + snstr + '00'
      window.external.WritePortData(data)
    },
    // 接收串口数据并处理
    RecvDataFromWinForm (data) {
      if (data.indexOf('$,') != -1 && data.indexOf(',%') != -1) {
        var dataList = data.split(',')
        var dataType = dataList[1]
        if (dataType == '1') {
          var rvType = dataList[2]
          if (rvType == '1') {
            this.AddPortDataList('设置用户ID，指令收到')
          }
          if (rvType == '2') {
            this.AddPortDataList('设置用户初始屈光度，指令收到')
          }
          if (rvType == '9') {
            this.AddPortDataList('清空用户使用时长，指令收到')
          }
          if (rvType == '10') {
            this.AddPortDataList('机构检测，指令收到')
          }
          if (rvType == '11') {
            this.AddPortDataList('设置产品设备号，指令收到')
          }
          if (rvType == '12') {
            this.AddPortDataList('语音检测，指令收到')
          }
        }
        if (dataType == '2') {
          this.deviceUserId = dataList[2] + dataList[3] + dataList[4] + dataList[5]
          this.AddPortDataList('查询用户ID，指令收到')
        }
        if (dataType == '3') {
          this.portDataDianJi1 = dataList[2]
          this.portDataDianJi2 = dataList[3]
          this.portDataDianJi3 = dataList[4]
          this.portDataDianJi4 = dataList[5]
        }
        if (dataType == '4') {
          this.portDataLight = dataList[3]
          this.portDataDistance = dataList[2]
        }
        if (dataType == '6') {
          this.portDataCurRangeIndex = dataList[2]
          this.AddPortDataList('查询区间，指令收到')
        }
        if (dataType == '7') {
          this.cpuId = dataList[2] + dataList[3] + dataList[4] + dataList[5] + dataList[6] + dataList[7] + dataList[8]
          this.AddPortDataList('芯片ID查询成功')
          //绑定
          if(this.QueryCpuIdType == 1){
            if(this.bznum == 0){
              this.bznum = 1
              this.RslEvBindGlassAndUser()
            }
          }
          //设置度数
          if(this.QueryCpuIdType == 2){
            this.RslEvPostSetDiopterLog()
          }
        }
        if (dataType == '8') {
          this.aCodeResult = dataList[2]
          this.AddPortDataList('授权结果：' + this.aCodeResult)
        }
        if (dataType == '9') {
          this.userTime = dataList[2]
          this.deviceTime = dataList[3]
          this.cpuId = dataList[4]
          this.deviceUserId = dataList[5]
          this.AddPortDataList('查询时长，指令收到')
          this.RslEvAddCpuIdTime()
        }
        if (dataType == '10') {
          this.deviceDiopter = dataList[2]
          this.AddPortDataList('屈光度：' + this.deviceDiopter)
        }
        if (dataType == '12') {
          this.AddPortDataList('♡')
          this.HeartbeatPackets()
        }
        this.dkorgb = '已打开'
      } else if (data.indexOf('Vol:') != -1) {
        this.vol = data
        this.AddPortDataList(data)
        this.dkorgb = '已打开'
      } else if (data.indexOf('请确保眼镜开机并且连线正常') != -1) {
        this.AddPortDataList(data)
        this.dkorgb = '异常'
      } else {
        this.AddPortDataList(data)
        this.dkorgb = '已打开'
      }
    },
    AddPortDataList (msg) {
      var d = new Date()
      var hour = d.getHours()
      hour = hour > 9 ? hour : '0' + hour.toString()
      var minute = d.getMinutes()
      minute = minute > 9 ? minute : '0' + minute.toString()
      var second = d.getSeconds()
      second = second > 9 ? second : '0' + second.toString()
      var curTime = '' + hour + ':' + minute + ':' + second
      this.portDataList.push({ time: curTime, rv: msg })

      var that = this
      this.$nextTick(() => {
        const portMsgBox = that.$refs.portMsgBox
        portMsgBox.scrollTop = portMsgBox.scrollHeight
      })
    },
    /// /////
    Quit () {
      Vue.prototype.QuitRslEv()
    },
    // 点击绑定：先查询用户信息，再查询CpuId，再调用接口绑定
    clickQuery () {
      this.RslEvGetUser()
    },
    // 点击设置度数：先查询CpuId，再查询度数是否合适并上传记录，再设置度数
    clickSetDiopter () {
      this.QueryCpuIdType = 2
      this.QueryCpuId()
    },
    RslEvGetUser: function () {
      this.bznum = -1
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        loginname: that.userzh
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignRslEv(data)
      axios.post(Vue.prototype.global.Url_RslEvGetUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          if (response.data.Code == 200) {
              that.userzh = response.data.LoginName
              that.bznum = 0
              that.QueryCpuIdType = 1
              that.QueryCpuId()
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    RslEvBindGlassAndUser: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        cpuid: that.cpuId,
        loginname: that.userzh
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignRslEv(data)
      axios.post(Vue.prototype.global.Url_RslEvBindGlassAndUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          if (response.data.Code == 200) {
              that.bznum = 2
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    RslEvPostSetDiopterLog: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        cpuid: that.cpuId,
        diopter: that.setDataDiopter
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignRslEv(data)
      axios.post(Vue.prototype.global.Url_RslEvPostSetDiopterLog, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          if (response.data.Code == 200) {
            that.SetDiopter()
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    RslEvAddCpuIdTime: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        cpuid: that.cpuId,
        usertime: that.userTime,
        devicetime: that.deviceTime,
        cpuid: that.cpuId,
        userid: that.deviceUserId
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignRslEv(data)
      axios.post(Vue.prototype.global.Url_RslEvAddCpuIdTime, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    RslEvCheckLogin: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignRslEv(data)
      axios.post(Vue.prototype.global.Url_RslEvCheckLogin, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code !== 200) {
            Vue.prototype.QuitRslEv()
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  },
  mounted () {
    this.RslEvCheckLogin()
    Vue.prototype.CheckRslEvKeyWord()

    this.Roletype = localStorage.getItem('Roletype')

    window.RecvDataFromWinForm = this.RecvDataFromWinForm

    document.body.addEventListener('click', () => {
      this.flag2 = false
    })

    // 串口号
    this.list = []
    for (var i = 1; i <= 16; i++) {
      this.list.push('COM' + i)
    }
  }
}
</script>
<style scoped>
  h3{
    margin: 0;
  }
.head {
  /* height: 74px; */
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  color: #1f216e;
  /* line-height: 74px; */
  text-indent: 2em;
  text-align: left;
}
.storebox {
  width: 960px;

  height: 720px;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
}
.storeboxr {
  width: 440px;
}
.storeboxl {
  width: 440px;
}
.ckszbox {
  position: relative;
  width: 440px;
  height: 146px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
}
.ckszbox > h3 {
  height: 58px;
  text-align: left;
  text-indent: 2em;
  line-height: 58px;
  border-bottom: 1px #f1f5f6 solid;
  font-size: 19px;
  font-weight: bold;
  color: #1f216e;
  margin: 0;
}
.ckszboxnr {
  position: relative;
  margin-top: 25px;
  margin-left: 37px;
  display: flex;
  width: 271px;
  height: 37px;
  background: #e0e6ff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  line-height: 37px;
}
.ckszboxnr > .title {
  display: block;
  width: 62px;
  height: 37px;
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
  line-height: 37px;
  text-indent: 1em;
}

.ckszboxnr > div {
  margin-left: 18px;
  margin-top: 3px;
  display: flex;
  width: 189px;
  height: 31px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
}
.ckszboxnr > div > h3 {
  display: block;
  width: 155px;
  height: 37px;
  line-height: 37px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: #222222;
  text-indent: 2em;
}
.ckszboxnr > .xzq {
  position: absolute;
  top: 37px;
  left: 80px;
  width: 155px;
  text-align: left;
  height: 137px;
  background: #ffffff;
  overflow: auto;
  opacity: 1;
}
.ckszboxnr > .xzq > li {
  font-size: 14px;
  font-weight: 400;
  color: #222222;
  border-bottom: 1px rgb(74, 68, 68) solid;
  text-indent: 2em;
}
.ckszboxnr > div > .clan {
  margin-top: 2px;
  width: 32px;
  height: 27px;
  background: #e0e6ff;
  border-radius: 0px 5px 5px 0px;
  opacity: 1;
}
.ckszboxnr > div > .clan > img {
  display: block;
  width: 15px;
  height: 11px;
  margin-top: 8px;
  margin-left: 9px;
  transform: rotate(360deg);
  transition: all 0.5s;
}
.ckszboxnr > div > .clan > .active {
  transform: rotate(180deg);
  transition: all 0.5s;
}
.dkan {
  margin-top: 20px;
  margin-left: 37px;
  display: flex;
  justify-content: space-between;
  width: 120px;
  height: 29px;
  opacity: 1;
  line-height: 29px;
  font-size: 14px;
}
.dkan > div {
  box-shadow: 0px 4px 25px 1px rgba(0, 20, 219, 0.12);
  border-radius: 5px 5px 5px 5px;
  width: 50px;
  height: 29px;
  opacity: 1;
  color: #000;
  text-align: center;
  line-height: 29px;
}
.ckszboxnr>.dkzt{
  position: absolute;
  top: 0;
  right: -66px;
 background:#e0e6ff;
 width: 50px;
 height: 30px;
 line-height: 30px;
 text-indent: 0.3em;
}

.szyj {
  margin-top: 40px;
  width: 440px;
  height: 156px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
}
.szyj > h3 {
  height: 58px;
  text-align: left;
  text-indent: 2em;
  line-height: 80px;
  border-bottom: 1px #f1f5f6 solid;
  font-size: 19px;
  font-weight: bold;
  color: #1f216e;
}
.szyj > div {
  display: flex;
}
.szyj > div > div {
  display: flex;
}
.szyjt {
  width: 368px;
  margin: 0 auto;
  margin-top: 25px;
  justify-content: space-between;
}
.szyjt > .zh {
  width: 271px;
  height: 37px;
  background: #e0e6ff;
  border-radius: 5px 5px 5px 5px;
  opacity: 0.5;
}
.szyjt > .zh > div {
  width: 78px;
  height: 37px;
  line-height: 37px;
  text-align: center;
  font-size: 14px;

  font-weight: 500;
  color: #1f216e;
}
.szyjt > .zh > input {
  margin-top: 2px;
  width: 189px;
  height: 31px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border-style: none;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  text-indent: 1.5em;
}
.szyjt > .zh > input:focus {
  outline: none;
}

.szyjt > .cx {
  margin-top: 2px;
  display: block;
  width: 41px;
  height: 29px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #dadcf7;
  font-size: 14px;
  font-weight: 500;
  color: #2c30b6;
  line-height: 29px;
  text-align: center;
}

.szyjt > .zc {
  margin-top: 2px;

  display: block;
  width: 41px;
  height: 29px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #dadcf7;
  font-size: 14px;
  font-weight: 500;
  color: #2c30b6;
  line-height: 29px;
  text-align: center;
}
.szyjb {
  width: 368px;
  margin: 8px auto;
  justify-content: space-around;
}
.szyjb > div {
  width: 140px;
  font-size: 12px;
  font-weight: 500;
  color: #676887;
  opacity: 1;
}
.szyjb > div > span {
  width: 47px;
  height: 18px;
  font-size: 12px;
  font-weight: 500;
  color: #1f216e;
  line-height: 18px;
  margin-left: 10px;
  text-align: right;
}
.qgd {
  width: 100%;
}
.qgd > h3 {
  text-align: center;
  display: block;
  width: 100%;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  font-weight: bold;
  color: #1f216e;
  margin: 0;
}
.qgdbox1 {
  margin: 0 auto;
  width: 390px;
  height: 143px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
}
.qgdbox1 > li {
  height: 35px;
  width: 340px;
  margin: 0 auto;
  display: flex;
  border-bottom: 1px #eff3f4 solid;
  justify-content: space-around;
}
.qgdbox1 > .qgdnr > div {
  width: 100px;
  line-height: 35px;
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  color: #676887;
}

.qgdbox1 > .qgdnr > div > span {
  width: 38px;
  height: 21px;
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
  margin-left: 10px;
}
.qgdnehead > div {
  display: block;
  width: 69px;
  height: 35px;
  font-size: 12px;
  font-weight: 500;
  color: #676887;
  line-height: 35px;
  text-align: center;
}
.qgdbox2 {
  margin: 0 auto;
  margin-top: 14px;
  width: 390px;
  height: 35px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  display: flex;
  justify-content: space-around;
  line-height: 35px;
}
.qgdbox2 > div {
  width: 109px;
  line-height: 35px;
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  color: #676887;
}

.qgdbox2 > div > span {
  width: 38px;
  height: 21px;
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
  margin-left: 10px;
}
.qgdbox3 {
  width: 390px;
  margin: 31px auto;
  display: flex;
  justify-content: space-around;
}
.qgdbox3 > div {
  width: 105px;
  height: 29px;
  background: #4c5cf7;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  line-height: 29px;
  text-align: center;
}
.zjjcbox {
  width: 440px;
  height: 362px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
}
.zjjcbox > h3 {
  height: 30px;
  text-align: left;
  text-indent: 2em;
  line-height: 30px;
  border-bottom: 1px #f1f5f6 solid;
  font-size: 19px;
  font-weight: bold;
  color: #1f216e;
}
.zjjcboxnr1 {
  display: flex;
  width: 340px;
  margin: 20px auto;
}
.zjjcboxnr1 > .zjjcboxnr1l {
  width: 87px;
  height: 29px;
  /* background: linear-gradient(180deg, #4254ff 0%, #63aafd 100%); */
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  text-align: center;
  line-height: 29px;
  margin-right: 20px;
}
.zjjcboxnr1 > .zjjcboxnr1l:hover{
  background: linear-gradient(180deg, #4254ff 0%, #63aafd 100%);
}
.zjjcboxnr1 > div {
  display: flex;
  width: 233px;
  height: 39px;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #dde2fa;
  line-height: 39px;
  justify-content: space-around;
}
.zjjcboxnr1 > div > div {
  font-size: 12px;

  font-weight: 500;
  color: #676887;
}
.zjjcboxnr1 > div > div > span {
  font-size: 14px;

  font-weight: 500;
  color: #1f216e;
}

.zjjcboxnr2 {
  display: flex;
  width: 340px;
  margin: 0px auto;
}
.zjjcboxnr2 > .zjjcboxnr2l {
  width: 87px;
  height: 29px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #dadcf7;
  line-height: 29px;
  text-align: center;
  line-height: 29px;
  margin-right: 20px;
}
.zjjcboxnr2 > .zjjcboxnr2l:hover{
  background: linear-gradient(180deg, #4254ff 0%, #63aafd 100%);
}
.zjjcboxnr2 > div {
  width: 233px;
  height: 99px;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #dde2fa;
}
.zjjcboxnr2 > div > div {
  display: flex;
  justify-content: space-around;
}
.zjjcboxnr2 > div > p {
  text-align: left;
  line-height: 18px;
  text-indent: 0.5em;
  margin-top: 4px;
}
.zjjcboxnr2 > div > p > span {
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
}
.zjjcboxnr2 > div > div > div {
  margin-top: 4px;
  width: 100px;
  display: flex;
  text-align: left;
  line-height: 18px;
}
.zjjcboxnr2 > div > div > div > span {
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
}
.zjjcboxnr3 > div > div > span {
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
}

.zjjcboxnr3 {
  display: flex;
  width: 340px;
  margin: 20px auto;
}

.zjjcboxnr3 > .zjjcboxnr3l {
  width: 87px;
  height: 29px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #dadcf7;
  line-height: 29px;
  text-align: center;
  line-height: 29px;
  margin-right: 20px;
}
.zjjcboxnr3 > .zjjcboxnr3l:hover{
  background: linear-gradient(180deg, #4254ff 0%, #63aafd 100%);
}
.zjjcboxnr3 > div {
  width: 233px;
  height: 69px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #dde2fa;
}
.zjjcboxnr3 > div > div {
  width: 157px;
  margin-left: 12px;
  margin-top: 12px;
  height: 18px;
  text-align: left;
  display: flex;
  font-size: 12px;
  font-weight: 500;
  color: #676887;
}
.zjjcboxnr3 > div > div > span {
  display: block;
  margin-left: 13px;
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
  margin-top: -1px;
}
.sjjsbox {
  width: 440px;
  height: 350px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  /* margin-bottom: 20px; */
  overflow: hidden;
}
.sjjsbox > h3 {
  height: 58px;
  text-align: left;
  text-indent: 2em;
  line-height: 58px;
  border-bottom: 1px #f1f5f6 solid;
  font-size: 19px;
  font-weight: bold;
  color: #1f216e;
  margin: 0;
  display: flex;
}
.sjjsbox > h3>span{
  display: block;
  width: 100px;
  height: 30px;
  color: #2c30b6;
  border-bottom: 1px  #000 soild;
  cursor: pointer;
  text-decoration:underline;
  margin-left: 180px;
}
.sjjsbox > div {
  overflow: hidden;
  margin-top: 16px;
  background: #f7fbfc;
}
.sjjsbox > div > p {
  width: 340px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  font-weight: 500;
  color: #676887;
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
}
.sjjsbox > div > p > .hy {
  display: block;
  width: 24px;
  height: 18px;
  width: 100px;
  text-align: center;
  margin-left: -228px;
}
.sjjsbox > div > p>.time{
  margin-left: -128px;
}
.sjjsbox > div > div {
  margin-top: 5px;
  overflow: auto;
  width: 390px;
  height: 260px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}
.sjjsbox > div > div > li {
  width: 340px;
  height: 30px;
  line-height: 30px;
  border-bottom: 1px #eff3f4 solid;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}
.sjjsbox > div > div > .active > span {
  display: block;
  width: 100px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #1f216e;
  line-height: 30px;
  text-align: left;
}
.sjjsbox > div > div > li >.time{
  display: block;
  width: 100px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #1f216ead;
  line-height: 30px;
  text-align: left;
}
.sjjsbox > div > div > li > span {
  display: block;
  width: 250px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #1f216ead;
  line-height: 30px;
  text-align: left;
}
.zcyh > h3 {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  font-weight: bold;
  color: #1f216e;
  text-align: left;
  text-indent: 2em;
  border-bottom: 1px #f1f5f6 solid;
}
.zcyh > div {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.zcyh > div > div {
  margin-top: 10px;
  width: 190px;
  height: 37px;
  background: #e0e6ff;
  border-radius: 5px 5px 5px 5px;
  opacity: 0.5;
  line-height: 37px;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
  text-indent: 0.5em;
}

.zcyh > div > div > input {
  margin-left: 7px;
  margin-top: 2px;
  width: 143px;
  height: 31px;
  background: #ffffff;
  border-style: none;
}
.qgzt > h3 {
  text-align: center;
  display: block;
  width: 100%;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  font-weight: bold;
  color: #1f216e;
}
.qgzt > div {
  margin: 0 auto;
  width: 390px;
  height: 71px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.qgzt > div > div {
  margin-right: 10px;
  display: flex;
  width: 80px;
  height: 15px;
  line-height: 15px;
  font-size: 14px;

  font-weight: 500;
  color: #1f216e;
}
.qgzt > div > div > div {
  width: 15px;
  height: 15px;
  opacity: 1;
  border: 1px solid #5338cd;
  border-radius: 50%;
  margin-right: 7px;
}
.zcan {
  text-align: center;
  margin: 25px auto;
  width: 105px;
  height: 29px;
  background: #4c5cf7;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  line-height: 29px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}

.zctc {
  position: fixed;
  top: 0;
  width: 960px;
  height: 720px;
  background: rgba(0, 0, 0, 0.4);
}
.zctc > div {
  width: 440px;
  height: 635px;
  margin: 80px auto;
  background: #ffffff;
  position: relative;
}
.xlkzj {
  width: 100%;
  height: 130px;
  background: #FFFFFF;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 6px;
  border-top: 1px #232223 solid;
}
.xlkzj>h3{
  display: block;
  text-align: center;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #000;
}
.xlkzj >div{
  height: 110px;
  overflow: auto;
}
.xlkzj >div>li{
  text-align: center;
}
.xlkzj2 {
  width: 100%;
  height: 130px;
  background: #FFFFFF;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 6px;
  border-top: 1px #232223 solid;
}
.xlkzj2 >div{
  height: 110px;
  overflow: auto;

}
.xlkzj2 >div>li{
  text-align: center;
}
.xlkzj2>h3{
  display: block;
  text-align: center;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #000;
}


.diopterbox{
  margin-top: 20px;
  width: 440px;
height: 146px;
background: #FFFFFF;
border-radius: 5px 5px 5px 5px;
opacity: 1;
}

.diopterbox>h3{
  height: 58px;
  text-align: left;
  text-indent: 2em;
  line-height: 58px;
  border-bottom: 1px #f1f5f6 solid;
  font-size: 19px;
  font-weight: bold;
  color: #1f216e;
  background: #ffffff;
}
.diopterbox > div > li {
  width: 368px;
  margin: 25px auto;
  display: flex;
  justify-content: space-between;
}

.diopterbox  > div > li > div {
  width: 271px;
  height: 37px;
  background: #e0e6ff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  display: flex;
}
.diopterbox  > div > li > div > span {
  display: block;
  width: 75px;
  line-height: 37px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #1f216e;
}
.diopterbox  > div > li > div>input{
 width: 189px;
height: 31px;
background: #FFFFFF;
border-radius: 5px 5px 5px 5px;
opacity: 1;
border-style: none;
margin-top: 3px;
text-align: left;
text-indent: 1em;
}
.diopterbox  > div > li > div>input:focus{
  border: 0px;
}
.diopterbox  > div > li>span{
  margin-top: 2px;
  display: block;
  width: 41px;
  height: 29px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #dadcf7;
  font-size: 14px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #2c30b6;
  line-height: 29px;
  cursor: pointer;
  text-align: center;
}
.diopterbox>div>li>span:hover{
  background: linear-gradient(180deg, #4254ff 0%, #63aafd 100%);
}
</style>
